export enum tcohV2Advies {
    geen_opvolging_noodzakelijk = 'Geen opvolging noodzakelijk',
    geruststellen_expectatief_beleid = 'Geruststellen / expectatief beleid',
    overweeg_aanvullend_slaaponderzoek_naar_osas_viaKsyos = 'Overweeg aanvullend slaaponderzoek naar OSAS via Ksyos',
    overweeg_opvolgend_teleconsult_cardioloog_via_ksyos = 'Overweeg opvolgend teleconsult cardioloog via Ksyos',
    overweeg_verwijzing_polikliniek_cardiologie = 'Overweeg verwijzing polikliniek cardiologie',
    spoed_verwijs_patient_naar_eerste_harthulp = 'Spoed, verwijs patiënt naar eerste (hart)hulp',
}
